<template>
  <AssetableLink v-if="type === 'links'" :without-actions="withoutActions" :link="assetable" />

  <AssetableNote
    v-else-if="type === 'notes'"
    :without-actions="withoutActions"
    :note="assetable"
    @view="$emit('view-note')"
  />

  <AssetableMedia
    v-else-if="type === 'media'"
    :without-actions="withoutActions"
    :media="assetable"
  />

  <div v-else>Unknown asset type</div>
</template>

<script>
import AssetableLink from './AssetableLink.vue';
import AssetableNote from './AssetableNote.vue';
import AssetableMedia from './AssetableMedia.vue';

export default {
  name: 'Assetable',
  components: {
    AssetableLink,
    AssetableNote,
    AssetableMedia,
  },
  props: {
    withoutActions: Boolean,
    assetable: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
